import { render, staticRenderFns } from "./RoomTestbankHistoryList.vue?vue&type=template&id=265f7dbe&"
import script from "./RoomTestbankHistoryList.vue?vue&type=script&lang=js&"
export * from "./RoomTestbankHistoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('265f7dbe')) {
      api.createRecord('265f7dbe', component.options)
    } else {
      api.reload('265f7dbe', component.options)
    }
    module.hot.accept("./RoomTestbankHistoryList.vue?vue&type=template&id=265f7dbe&", function () {
      api.rerender('265f7dbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/Testbank/History/RoomTestbankHistoryList.vue"
export default component.exports